/**
 * FollowBanner - "Following <presenter>" banner (bottom-center) with the
 * Stop escape hatch. React port of multiplayerUI's showFollowBanner; the
 * never-trap-users Stop contract is unchanged. The callback stays in the
 * handler registry, outside the data-only HUD snapshot.
 */
import { useStore } from 'zustand';
import { Footprints } from 'lucide';
import { hudStore } from '../../state/hudStore';
import { Icon } from './Icon';
import type { LucideIconNode } from '../../utils/iconCanvas';
import { getFollowStop } from './handlerRegistry';

export function FollowBanner() {
  const banner = useStore(hudStore, (s) => s.followBanner);
  if (!banner) return null;

  return (
    <div
      id="follow-banner"
      style={{
        background: 'rgba(0,150,90,0.92)',
        color: '#fff',
        padding: '8px 14px',
        borderRadius: '10px',
        fontFamily: 'sans-serif',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        boxShadow: '0 2px 12px rgba(0,0,0,0.35)',
        pointerEvents: 'auto',
      }}
    >
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
        <Icon icon={Footprints as unknown as LucideIconNode} size={16} />
        {`Following ${banner.presenterName} - move to take back control`}
      </span>
      <button
        type="button"
        onClick={() => getFollowStop()?.()}
        style={{
          border: 'none',
          borderRadius: '6px',
          background: 'rgba(255,255,255,0.25)',
          color: '#fff',
          fontSize: '12px',
          padding: '3px 10px',
          cursor: 'pointer',
        }}
      >
        Stop
      </button>
    </div>
  );
}
